// Portfolio Administration v1.0 PR 5 — read-only star rendering helper
// used by the Vendors + Local Enforcers Performance tabs. Supports
// half-star granularity at the row-summary level; the detail card lists
// the numeric value alongside.

import { Star, StarHalf } from "lucide-react";

export interface RatingStarsProps {
  rating: number | null | undefined;
  /** Show the numeric value next to the stars (default true). */
  showValue?: boolean;
  size?: "sm" | "md";
  testId?: string;
}

export function RatingStars({
  rating,
  showValue = true,
  size = "sm",
  testId,
}: RatingStarsProps) {
  const px = size === "md" ? 16 : 12;
  if (rating === null || rating === undefined) {
    return (
      <span
        className="text-small text-gray-mid italic"
        data-testid={testId}
      >
        — Unrated
      </span>
    );
  }
  const safe = Math.max(0, Math.min(5, rating));
  const full = Math.floor(safe);
  const half = safe - full >= 0.25 && safe - full < 0.75;
  const empty = 5 - full - (half ? 1 : 0);
  return (
    <span
      className="inline-flex items-center gap-space-1"
      data-testid={testId}
    >
      <span className="inline-flex">
        {Array.from({ length: full }).map((_, i) => (
          <Star
            key={`f-${i}`}
            size={px}
            className="text-gold fill-gold"
            aria-hidden="true"
          />
        ))}
        {half ? (
          <StarHalf
            size={px}
            className="text-gold fill-gold"
            aria-hidden="true"
          />
        ) : null}
        {Array.from({ length: empty }).map((_, i) => (
          <Star
            key={`e-${i}`}
            size={px}
            className="text-gray-soft"
            aria-hidden="true"
          />
        ))}
      </span>
      {showValue ? (
        <span className="text-small text-gray-mid">{safe.toFixed(1)}</span>
      ) : null}
    </span>
  );
}
